import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useContainerItem } from 'hamster-react';

import { ENTITY_DESCRIPTIONS } from 'cityads-v3/store/configureHamster';

const ENTITY_NAMES = Object.keys(ENTITY_DESCRIPTIONS);

export default function LanguageListener() {
  const isInitialMount = useRef(true);
  const language = useSelector(state => state.language.language);

  const store = useContainerItem('store');
  const requestDispatcher = useContainerItem('request-dispatcher');

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      ENTITY_NAMES.forEach(entityName => {
        store.removeAllEntities(entityName);
        requestDispatcher.rejectAllPendingFetches(entityName, new Error('Language has been changed'));
      })
    }
  }, [language, store, requestDispatcher]);

  return null;
}
